export const SystemOptionMappings = [
  { field: "glAcctAR", key: 2 },
  { field: "glAcctSalesContract", key: 39 },
  { field: "glAcctContractDeferred", key: 90 },
  { field: "glAcctAP", key: 51 },

  { field: "glAcctSalesFlex", key: 3 },
  { field: "glAcctSalesFlexOut", key: 44 },
  { field: "glAcctPOFlex", key: 52 },
  { field: "glAcctPOFlexOut", key: 60 },

  { field: "glAcctSalesFlexSmall", key: 94 },
  { field: "glAcctSalesFlexOutSmall", key: 95 },
  { field: "glAcctPOFlexSmall", key: 84 },
  { field: "glAcctPOFlexOutSmall", key: 85 },

  { field: "glAcctSalesRgd", key: 4 },
  { field: "glAcctSalesRgdOut", key: 45 },
  { field: "glAcctPORgd", key: 53 },
  { field: "glAcctPORgdOut", key: 61 },

  { field: "glAcctSalesInst", key: 5 },
  { field: "glAcctSalesInstOut", key: 46 },
  { field: "glAcctPOInst", key: 54 },
  { field: "glAcctPOInstOut", key: 62 },

  { field: "glAcctSalesCam", key: 26 },
  { field: "glAcctSalesCamOut", key: 47 },
  { field: "glAcctPOCam", key: 55 },
  { field: "glAcctPOCamOut", key: 63 },

  { field: "glAcctPOGeneralLab", key: 97 },
  { field: "glAcctPOCogentix", key: 86 },
  { field: "glAcctPOFUSE", key: 87 },
  { field: "glAcctPOCarts", key: 88 },

  { field: "glAcctFuseContract", key: 75 },
  { field: "glAcctFuseTM", key: 76 },
  { field: "glAcctFuseOutsideUS", key: 77 },

  { field: "glAcctCostOfScopesSold", key: 92 },
  { field: "glAcctServicePlanCredit", key: 93 },
  { field: "servicePlanMonthlyCost", key: 91 },

  { field: "glAcctExpenseShipping", key: 82 },
  { field: "glAcctSalesShip", key: 6 },
  { field: "salesTaxPayable", key: 27 },
  { field: "glAcctInstrumentsForSale", key: 112 },
  { field: "glAcctCostOfInstrumentsSold", key: 113 },
  { field: "pastDueDays", key: 19 },
  { field: "profitMarginPctDef", key: 36 },
];
